import { Badge } from "@/components/ui/badge";
import { scoreColorClasses } from "@/lib/personaScore";
import { Trophy } from "lucide-react";

interface Props {
  score: number | undefined | null;
  className?: string;
}

export const PersonaScoreBadge = ({ score, className }: Props) => {
  if (score === undefined || score === null) {
    return (
      <Badge variant="outline" className={className}>
        Sem nota
      </Badge>
    );
  }
  return (
    <Badge variant="outline" className={`gap-1 ${scoreColorClasses(score)} ${className || ""}`}>
      <Trophy className="w-3 h-3" />
      Nota {score}
    </Badge>
  );
};
